module.exports = __webpack_public_path__ + "img/foto-perfil-default.782adc2b.png";